<style src="./Responsabilities.scss" lang="scss" scoped></style>
<template>
  <section class="client">
    <content-header path="Cadastro / Responsabilidades"/>

    <button class="btn-primary col-3" @click="addNew">
      <icon-add />
      <span class="hide-md">Inserir Novo</span>
    </button>

    <section class="form-box">
      <responsabilities-map :list-data="filteredList"/>
    </section>

    <right-side-panel ref="rspNewClient" title="Novo Cliente" :shortcut="['alt', 'n']">
      <new-responsabilities @refresh-list="refreshList" />
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
// import { Textbox } from '@/components/primitives'
// import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { NewResponsabilities, ResponsabilitiesMap } from './components'
import { GetClientList } from '@/brain/record/client'

let listData = []

export default {
  name: 'Responsabilities',
  components: {
    ContentHeader,
    RightSidePanel,
    NewResponsabilities,
    ResponsabilitiesMap
    // Textbox,
    // IconAdd,
    // IconEmpty
  },
  data () {
    return {
      searchText: '',
      filteredList: []
    }
  },
  watch: {
    searchText (pValue) {
      if (pValue.length > 0) {
        const filteredList = listData.filter((pItem) => {
          return pItem.name.toLowerCase().includes(pValue.toLowerCase())
        })
        this.filteredList = this.orderList(filteredList)
      } else {
        this.filteredList = this.orderList(listData)
      }
    }
  },
  mounted () {
    this.loadAll()
  },
  methods: {
    searchSubmit () {},
    refreshList () {
      this.loadAll()
    },
    loadAll () {
      GetClientList()
        .then((result) => {
          const listData = this.orderList(result)
          this.filteredList = listData
        })
    },
    addNew () {
      this.$refs.rspNewClient.showPanel()
    },
    cancelAddNew () {
    },
    addedSuccessful () {
      this.loadAll()
    },
    orderList: (pList) => {
      const r = Object.values(pList).sort((a, b) => {
        return b.shortName.trim() - a.shortName.trim()
      })
      return r
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/responsabilities/Responsabilities.vue